import React from 'react';

const ReferralContext = React.createContext({
  referralInfo: {},
  affiliateInfo: {},
});

export default ReferralContext;
